const ONE_MEGABYTE = 1048576;
export const MAX_IMAGE_UPLOAD_SIZE = ONE_MEGABYTE; // 1MB

export const SUPPORTED_FILE_TYPES = ['png', 'jpeg', 'jpg'];
